<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Plan purchase</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="page-pad">

    <div class="flex flex-row gap-2 justify-between items-center mb-4 px-2">
      <h1 type="button" class="text-lg m-0 font-bold"
        [class.cursor-pointer]="orgId"
        [class.hover:underline]="orgId"
        (click)="openOrganisation()">
        {{ orgName }}
      </h1>
      <span class="badge" [ngClass]="statusClass">{{ status }}</span>
    </div>

    <div class="cart-card">
      <div class="flex flex-row items-start justify-between gap-3">
        <div class="min-w-0">
          <p class="item-name">{{ purchase.plan?.name || 'Plan' }}</p>
          @if (purchase.plan?.type) {
          <p class="item-sub">{{ purchase.plan.type }}</p>
          }
        </div>
        @if (purchase.priceBreakup?.payableAmount != null) {
        <p class="item-price">₹{{ purchase.priceBreakup.payableAmount | number : '1.0-2' }}</p>
        }
      </div>

      @if (purchase.priceBreakup?.subtotal != null) {
      <div class="cart-totals">
        <div class="total-row">
          <span>Subtotal</span>
          <span>₹{{ purchase.priceBreakup.subtotal | number : '1.0-2' }}</span>
        </div>
        @if (purchase.priceBreakup.discountAmount) {
        <div class="total-row muted">
          <span>Discount</span>
          <span>- ₹{{ purchase.priceBreakup.discountAmount | number : '1.0-2' }}</span>
        </div>
        }
        @if (purchase.priceBreakup.taxAmount != null) {
        <div class="total-row muted">
          <span>Tax</span>
          <span>₹{{ purchase.priceBreakup.taxAmount | number : '1.0-2' }}</span>
        </div>
        }
        <div class="total-row total-row-final">
          <span>Total</span>
          <span>₹{{ purchase.priceBreakup.payableAmount | number : '1.0-2' }}</span>
        </div>
      </div>
      }

      <div class="cart-meta">
        <div class="meta-row">
          <span class="meta-label">ID</span>
          <div class="meta-value-row">
            <span class="meta-value mono">{{ purchase._id }}</span>
            <button type="button" class="copy-btn" (click)="copyValue(purchase._id)" aria-label="Copy">
              <ion-icon name="copy-outline"></ion-icon>
            </button>
          </div>
        </div>

        @if (purchase.activationTime) {
        <div class="meta-row">
          <span class="meta-label">Activated</span>
          <span class="meta-value">{{ purchase.activationTime | date : 'dd MMM yyyy, h:mm a' }}</span>
        </div>
        }

        @if (purchase.expireTime) {
        <div class="meta-row">
          <span class="meta-label">Expires</span>
          <div class="meta-value-row">
            <span class="meta-value">{{ purchase.expireTime | date : 'dd MMM yyyy, h:mm a' }}</span>
            @if (status === 'Active') {
            <button type="button" class="copy-btn" (click)="updateExpiry()" aria-label="Update expiry">
              <ion-icon name="pencil-outline"></ion-icon>
            </button>
            }
          </div>
        </div>
        }

        @if (purchase.planPricingModel?.validityDays) {
        <div class="meta-row">
          <span class="meta-label">Duration</span>
          <span class="meta-value">{{ purchase.planPricingModel.validityDays }} days</span>
        </div>
        }

        <div class="meta-row">
          <span class="meta-label">Auto-renew</span>
          <span class="meta-value">{{ purchase.autoRenews ? 'On' : 'Off' }}</span>
        </div>

        @if (purchase.razorpaySubscriptionId) {
        <div class="meta-row">
          <span class="meta-label">Subscription</span>
          <div class="meta-value-row">
            <span class="meta-value mono">{{ purchase.razorpaySubscriptionId }}</span>
            <button type="button" class="copy-btn" (click)="copyValue(purchase.razorpaySubscriptionId)" aria-label="Copy">
              <ion-icon name="copy-outline"></ion-icon>
            </button>
          </div>
        </div>
        }

        @if (purchase.deactivateRemark) {
        <div class="meta-row">
          <span class="meta-label">Remark</span>
          <span class="meta-value">{{ purchase.deactivateRemark }}</span>
        </div>
        }
      </div>
    </div>

    @if (canViewOrder || status === 'Active') {
    <div class="actions">
      @if (canViewOrder) {
      <super-button type="clear" size="v-small" (click)="openOrder()">
        <span class="underline">View order</span>
      </super-button>
      }
      @if (status === 'Active') {
      @if (canCancelSubscription()) {
      <super-button type="outline" size="v-small" [action]="cancelSubscription">
        Cancel subscription
      </super-button>
      }
      <super-button type="outline" size="v-small" [action]="removePlan">
        Remove plan
      </super-button>
      }
    </div>
    }

  </div>
</ion-content>
